import '../Styles/Modal.css';

import { useEffect } from 'react';

export function DialogModal({message, show, setDialogModal, setDecision, onModalClose}) {

    useEffect(() => {
        let dialog_modal_container = document.getElementById('dialog_modal_container');
        if(show) {
            dialog_modal_container.classList.add('show');
        }
        else {
            dialog_modal_container.classList.remove('show');
            if(onModalClose !== undefined)
                onModalClose();
        }
    }, [show]); 

    function closeYesModal() {
        setDialogModal(false);
        setDecision(true);
    }

    function closeNoModal() {
        setDialogModal(false);
        setDecision(false);
    }

    return (
        <div className='modal-container' id='dialog_modal_container'>
            <div className='modal'>
                <div className="modal-content">
                    <h1>
                    {message}
                    </h1>
                </div>
                <div className='modal-buttons'>
                    <div className="modal-button-left">
                        <button id="Yes-modal-button" className="Login-button" onClick={closeYesModal}><span>Yes</span></button>
                    </div>
                    <div className="modal-button-right">
                        <button id="No-modal-button" className="Login-button" onClick={closeNoModal}><span>No</span></button>
                    </div>
                </div>
            </div>
        </div>
    )
}
